<template>
  <section>
    <ResourcesResearchHeader />
    <ResourcesResearchIntro />
    <ResourcesResearchContent />
  </section>
</template>

<script>
import * as partials from './partials'

export default {
  name: 'ResourcesResearch',
  components: { ...partials },
  provide() {
    return {
      wp: this.$wp.pages['resources-research'] || {}
    }
  },
  mounted() {
    console.log('events', this.$wp.pages['resources-research'])
  }
}
</script>
